import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex h-screen flex-col items-center justify-center overflow-hidden bg-background-950 px-4 text-center">
      <div className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-accent-500/15 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -left-20 h-80 w-80 rounded-full bg-primary-500/15 blur-3xl" />
      <span className="relative font-heading text-8xl font-black text-gradient-gold md:text-[11rem]">404</span>
      <p className="relative mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">这页虚空里，什么都没有</p>
      <p className="relative mt-3 max-w-md text-sm text-foreground-500 md:text-base">
        你访问的页面「{location.pathname}」不存在，可能已经进入异世界了。回到首页，找一部漫画继续冒险吧。
      </p>
      <Link
        to="/"
        className="relative mt-8 cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-950 transition-colors hover:bg-primary-600"
      >
        返回首页
      </Link>
    </div>
  );
}